import { useState } from "react";
import { useForm } from "react-hook-form";
import changepasword_image from "../../assets/images/Auth/changepassword.png";
import logo from "../../assets/images/Auth/tt-logo.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import arrow from "../../assets/images/Auth/back_arrow.png";
import { postdatas, resetPassword } from "../../apis/apiService";
import { toast } from "react-toastify";

const ChangePassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();
  // const { token: email_token } = useParams();
  // // //console.log()("email_token : ", email_token);

  const navigate = useNavigate();
  const location = useLocation();
  // // //console.log()("email_token 1: ", token);
  const [showPassword, setShowPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const toggleOldPasswordVisibility = () => {
    setOldPassword((prev) => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const onSubmit = async (data) => {
    const { old_password, password, confirmPassword } = data;
    // //console.log()("passwordsss_data :", old_password, password, confirmPassword);

    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    setLoading(true);
    const requestedData = {
      old_password: old_password,
      new_password: password,
      new_password_confirmation: confirmPassword,
    };
    try {
      // Ensure token is passed in the URL and passwords in the body
      const response = await postdatas(
        "users",
        "changePassword",
        requestedData
      );

      toast.success(response.message || "Password changed successfull!");
      // //console.log()("reset_response", response.message);

      setTimeout(() => {
        navigate("/"); // Redirect to login after success
      }, 2000);
    } catch (error) {
      toast.error(error.message || "Invalid or expired token");
    } finally {
      setLoading(false);
    }
  };

  const password = watch("password");
  return (
    <>
      <div className="container-fluid ">
        <div className="row ">
          {/* Image Section */}
          <div className="col-md-7 text-center px-3 login_bg">
            <img
              src={changepasword_image}
              alt="Illustration"
              className="Authleft_img"
            />
          </div>
          {/* Form Section */}
          <div className="col-md-5 px-3">
            <div className="text-center">
              <img src={logo} alt="logo" />
            </div>
            <div className="form_title">
              <div className="d-flex">
                {/* <a
                  className="back_btn"
                  onClick={() => navigate("/forgot_password")}
                >
                  <img src={arrow} alt="arrow" className="" />
                </a> */}
                <h3>Change your Password</h3>
              </div>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} className="login_form">
              {/* New Password Field */}
              <div className="mb-1 position-relative">
                <label htmlFor="password" className="form-label">
                  Old Password <span className=" errorMsg">*</span>
                </label>
                <input
                  type={oldPassword ? "text" : "password"}
                  id="password"
                  className="form-control"
                  {...register("old_password", {
                    required: " Please enter old password",
                    // minLength: {
                    //   value: 6,
                    //   message: "Password must be at least 6 characters",
                    // },
                    validate: {
                      noSpaces: (value) =>
                        !/\s/.test(value) || "Password must not contain spaces",
                    },
                  })}
                />
                <span
                  onClick={toggleOldPasswordVisibility}
                  style={{
                    position: "absolute",
                    top: "55px",
                    right: "10px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                >
                  {/* {showPassword ? <FaEyeSlash /> : <FaEye />} */}
                  {oldPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
                {errors.old_password && (
                  <small className="text-danger">
                    {errors.old_password.message}
                  </small>
                )}
              </div>
              <div className="mb-1 position-relative">
                <label htmlFor="password" className="form-label">
                  New Password <span className=" errorMsg">*</span>
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  className="form-control"
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 6,
                      message: "Password must be at least 6 characters",
                    },
                    validate: {
                      noSpaces: (value) =>
                        !/\s/.test(value) || "Password must not contain spaces",
                    },
                  })}
                />
                <span
                  onClick={togglePasswordVisibility}
                  style={{
                    position: "absolute",
                    top: "55px",
                    right: "10px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                >
                  {/* {showPassword ? <FaEyeSlash /> : <FaEye />} */}
                  {showPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
                {errors.password && (
                  <small className="text-danger">
                    {errors.password.message}
                  </small>
                )}
              </div>

              {/* Confirm Password Field */}
              <div className="mb-3 position-relative">
                <label htmlFor="confirmPassword" className="form-label">
                  Confirm Password <span className=" errorMsg">*</span>
                </label>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  id="confirmPassword"
                  className="form-control"
                  {...register("confirmPassword", {
                    required: "Please confirm your password",
                    // validate: (value) =>
                    //   value === password || "Passwords do not match",
                    validate: {
                      value: (value) =>
                        value === password || "Passwords do not match",
                    },
                    noSpaces: {
                      value: (value) => !/\s/.test(value),
                      message: "Password must not contain spaces",
                    },
                  })}
                />
                <span
                  onClick={toggleConfirmPasswordVisibility}
                  style={{
                    position: "absolute",
                    top: "55px",
                    right: "10px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                >
                  {/* {showConfirmPassword ? <FaEyeSlash /> : <FaEye />} */}
                  {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
                {errors.confirmPassword && (
                  <small className="text-danger">
                    {errors.confirmPassword.message}
                  </small>
                )}
              </div>

              {/* Submit Button */}
              <div className="d-grid">
                <button type="submit" className="auth_btn" disabled={loading}>
                  {loading ? "Submiting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
